import { useEffect, useState } from 'react';

import { api, apiEndpoints } from '../utils/api';

export interface PricingTier {
  id: string;
  name: string;
  display_name: string;
  price: number;
  description?: string;
  features: string[];
  is_active: boolean;
  metadata?: {
    requires_sales_contact?: boolean;
    signup_enabled?: boolean;
    includes?: string;
    quota_prs_per_month?: number;
    quota_sast_scans_per_month?: number;
    quota_deep_scans_per_month?: number;
  };
}

interface PricingTiersState {
  tiers: PricingTier[] | null;
  loading: boolean;
  error: boolean;
}

// Fetches subscription tiers from the public (unauthenticated) endpoint for the pricing page.
// Uses the shared unauthenticated `api` client so it works for logged-out visitors (and Paddle
// reviewers). Dedicated hook so no raw API call lives in a component effect.
export function usePublicPricingTiers(): PricingTiersState {
  const [state, setState] = useState<PricingTiersState>({ tiers: null, loading: true, error: false });

  useEffect(() => {
    let cancelled = false;
    api
      .get<PricingTier[]>(apiEndpoints.billing.subscriptionTiers)
      .then((tiers) => {
        if (!cancelled) setState({ tiers: tiers || [], loading: false, error: false });
      })
      .catch(() => {
        if (!cancelled) setState({ tiers: null, loading: false, error: true });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
